import 'normalize.css';
import './styles/index.css';
import './styles/typography.css';

import('./app');
